// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__CeJfU","rootCenter":"LoadMoreObserver_rootCenter__2Xk0N","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2kmcU"};